import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.scss'

const Header = (props) => {
  const { brand } = props

  return (
    <div className={styles.root}>Hello, I am Header for {brand.title}</div>
  )
}

Header.propTypes = {
  brand: PropTypes.object.isRequired,
}

export default Header
